import React from "react"
import imageGridCSS from './ImageGrid.module.css'

export default function ImageGrid({ children, style }) {
   return <div style={style} className={imageGridCSS.imageGrid}>
      {children}
  </div>
}
